import ContactForm from "@/components/ContactForm";
import { motion } from "framer-motion";

export default function Contact() {
  return (
    <div data-testid="contact-page" className="pt-36">
      <div className="container-x">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <p className="eyebrow mb-4">Contact</p>
          <h1 className="font-serif-display text-5xl md:text-7xl leading-[1.02] tracking-tight text-[#1E2A25] max-w-4xl">
            Talk to us. <span className="italic text-[#4A5D52]">We&apos;ll listen first.</span>
          </h1>
          <p className="mt-8 max-w-xl text-lg text-[#4A5D52] leading-relaxed">
            Tell us a little about your team or your training goals, and we&apos;ll be in touch —
            usually within one working day.
          </p>
        </motion.div>
      </div>
      <ContactForm />
    </div>
  );
}
